.container {
  display: grid;
  gap: 10px;

  @media screen and (width >= 769px) {
    gap: 16px;
  }
}

.pulldownRow {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 32px;
  gap: 8px;
  align-items: center;

  @media screen and (width >= 769px) {
    grid-template-columns: 187px 32px;
  }
}

.pulldown {
  width: 100% !important;

  @media screen and (width >= 769px) {
    width: 187px !important;
  }
}

.clearButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  justify-self: end;
  width: 32px;
  height: 32px;
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: none;

  &:focus-visible {
    outline: 2px solid #358cda;
    outline-offset: 2px;
  }

  &[aria-disabled='true'] {
    cursor: default;
    opacity: 0.5;
  }
}

.clearIcon {
  width: 28px;
  height: 28px;
}
